import axios from 'axios';

// Testing API endpoint
// const API_ENDPOINT = "https://admin.support-api.yukthi.net";

// Production API endpoint
const API_ENDPOINT = "https://admin-support.api.yukthi.net";


// Valiating session id api call
const validateSession = async (session_id) => {
    try {
        let config = {
            method: 'get',
            url: `${API_ENDPOINT}/session/validate/${session_id}`,
            headers: {
                'accept': 'application/json',
            },
            timeout: 5 * 1000,
        };
        const response = await axios.request(config);
        return response;
    } catch (error) {
        if (error.response.data) {
            throw new Error(`Status code: ${error.response.status} Message: ${error.response.data}`);
        } else if (error.request) {
            throw new Error(error.message);
        }
        throw new Error(`Status code: ${error.response.status} Message: ${error.message}`);
    }
};

// Validataing user local_part
const validateUserLocalPart = async (session_id, domain_id, local_part) => {
    try {
        const params = {
            local_part: local_part,
            domain_id: domain_id
        }
        let config = {
            method: 'get',
            url: `${API_ENDPOINT}/mailbox/validate`,
            headers: {
                'accept': 'application/json',
                'Session-ID': `${session_id}`,
            },
            params: params,
            timeout: 5 * 1000,
        };
        const response = await axios.request(config);
        return response;
    } catch (error) {
        if (error.response.data) {
            throw new Error(`Status code: ${error.response.status} Message: ${error.response.data}`);
        } else if (error.request) {
            throw new Error(error.message);
        }
        throw new Error(`Status code: ${error.response.status} Message: ${error.message}`);
    }
}


// Getting user infromation api call
const userInfo = async (session_id) => {
    try {
        let config = {
            method: 'get',
            url: `${API_ENDPOINT}/mailbox/info`,
            headers: {
                'accept': 'application/json',
                'Session-ID': `${session_id}`,
            },
            timeout: 5 * 1000,
        };
        const response = await axios.request(config);
        return response.data;
    } catch (error) {
        if (error.response.data) {
            throw new Error(`Status code: ${error.response.status} Message: ${error.response.data}`);
        } else if (error.request) {
            throw new Error(error.message);
        }
        throw new Error(`Status code: ${error.response.status} Message: ${error.message}`);
    }
};


// User create 
const createUserInfo = async (session_id, user) => {
    try {
        let config = {
            method: 'post',
            url: `${API_ENDPOINT}/mailbox/create`,
            headers: {
                'accept': 'application/json',
                'Session-ID': `${session_id}`,
            },
            data: user,
            timeout: 5 * 1000,
        };
        return await axios.request(config);
    } catch (error) {
        if (error.response.data) {
            throw new Error(`Status code: ${error.response.status} Message: ${error.response.data}`);
        } else if (error.request) {
            throw new Error(error.message);
        }
        throw new Error(`Status code: ${error.response.status} Message: ${error.message}`);
    }
};

// getting avaliable quota.
const gettingDomainQuota = async (session_id, domain_id) => {
    try {
        let config = {
            method: 'get',
            url: `${API_ENDPOINT}/mailbox/available-quota/${domain_id}`,
            headers: {
                'accept': 'application/json',
                'Session-ID': `${session_id}`,
            },
            timeout: 5 * 1000,
        };
        return await axios.request(config);
    } catch (error) {
        if (error.response.data) {
            throw new Error(`Status code: ${error.response.status} Message: ${error.response.data}`);
        } else if (error.request) {
            throw new Error(error.message);
        }
        throw new Error(`Status code: ${error.response.status} Message: ${error.message}`);
    }

}


// Update user infromation (edit form)
const updateUserInfo = async (session_id, user) => {
    try {
        let config = {
            method: 'post',
            url: `${API_ENDPOINT}/mailbox/update`,
            headers: {
                'accept': 'application/json',
                'Session-ID': `${session_id}`,
            },
            data: user,
            timeout: 5 * 1000,
        };
        return await axios.request(config);
    } catch (error) {
        if (error.response.data) {
            throw new Error(`Status code: ${error.response.status} Message: ${error.response.data}`);
        } else if (error.request) {
            throw new Error(error.message);
        }
        throw new Error(`Status code: ${error.response.status} Message: ${error.message}`);
    }
};


// Update new password
const newPasswordUpdate = async (session_id, password) => {
    try {
        let config = {
            method: 'put',
            url: `${API_ENDPOINT}/mailbox/password/update`,
            headers: {
                'accept': 'text/plain',
                'Session-ID': `${session_id}`,
            },
            data: `${btoa(`${password}`)}`,
            timeout: 5 * 1000,
        };
        return await axios.request(config);
    } catch (error) {
        if (error.response.data) {
            throw new Error(`Status code: ${error.response.status} Message: ${error.response.data}`);
        } else if (error.request) {
            throw new Error(error.message);
        }
        throw new Error(`Status code: ${error.response.status} Message: ${error.message}`);
    }
};

// Getting all user data to export.
const getAllUserDataToExport = async (session_id, domain_ids) => {
    try {
        let config = {
            method: 'post',
            url: `${API_ENDPOINT}/mailbox/export`,
            headers: {
                'accept': 'application/json',
                'Session-ID': `${session_id}`,
            },
            data: domain_ids,
            // timeout: 60 * 1000,
        };
        return await axios.request(config);
    } catch (error) {
        if (error.response.data) {
            throw new Error(`Status code: ${error.response.status} Message: ${error.response.data}`);
        } else if (error.request) {
            throw new Error(error.message);
        }
        throw new Error(`Status code: ${error.response.status} Message: ${error.message}`);
    }
};

// Bulk create user info.
const userBulkCreateImport = async (session_id, user) => {
    try {
        let config = {
            method: 'post',
            url: `${API_ENDPOINT}/mailbox/import/create`,
            headers: {
                'accept': 'application/json',
                'Session-ID': `${session_id}`,
            },
            data: user,
            // timeout: 5 * 1000,
        };
        return await axios.request(config);
    } catch (error) {
        if (error.response.data) {
            throw new Error(`Status code: ${error.response.status} Message: ${error.response.data}`);
        } else if (error.request) {
            throw new Error(error.message);
        }
        throw new Error(`Status code: ${error.response.status} Message: ${error.message}`);
    }
};


// Bulk Edit user info.
const userBulkEditImport = async (session_id, user) => {
    try {
        let config = {
            method: 'post',
            url: `${API_ENDPOINT}/mailbox/import/update`,
            headers: {
                'accept': 'application/json',
                'Session-ID': `${session_id}`,
            },
            data: user,
            // timeout: 5 * 1000,
        };
        return await axios.request(config);
    } catch (error) {
        if (error.response.data) {
            throw new Error(`Status code: ${error.response.status} Message: ${error.response.data}`);
        } else if (error.request) {
            throw new Error(error.message);
        }
        throw new Error(`Status code: ${error.response.status} Message: ${error.message}`);
    }
};



export {
    validateSession, userInfo, createUserInfo, updateUserInfo,
    newPasswordUpdate, getAllUserDataToExport, userBulkEditImport,
    userBulkCreateImport, validateUserLocalPart, gettingDomainQuota
};
